
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import ShowModal from '../showModal/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    ShowModal,
    LazyImg
  }
})
export default class extends Vue {
  get Global() {
    return this.$store.$global
  }

  showData = [
    {
      imgList: [
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item0-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item1-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item2-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item3-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item4-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item5-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item6-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item7-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item8-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item9-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item10-v4.jpg`,
        `${this.Global.static}/images/about-xuantong/pc/about_xuantong_tong_more_how_register_item11-v6.jpg`
      ],
      text: '去报名',
      type: 'jump',
      jumpUrl: '/'
    },
    {
      imgList: [
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item0-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item1-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item2-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item3-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item4-v2.png`
      ],
      text: '暄桐书单',
      type: 'download'
    }
  ]

  activeIndex: number = 0

  visibleShowModal: boolean = false

  handleToBook(book: number) {
    window.open(`/books?id=${book}`)
  }

  handleOpenShowModal() {
    this.visibleShowModal = !this.visibleShowModal
  }

  handleOpenBook() {
    this.activeIndex = 1

    this.handleOpenShowModal()
  }

  handleOpenIns() {
    window.open('https://mp.weixin.qq.com/s/-sySInlQ6DmXqjZh2nh2cA')
  }

  handleOpenVideo() {
    window.open('/video')
  }

  handleOpenBmkc() {
    this.activeIndex = 0

    this.handleOpenShowModal()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
